import React from "react";

export const DesktopVersionIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 1.875H5C2.985 1.875 1.875 2.985 1.875 5V11.6667C1.875 13.6817 2.985 14.7917 5 14.7917H7.70833V16.875H6.25C5.905 16.875 5.625 17.155 5.625 17.5C5.625 17.845 5.905 18.125 6.25 18.125H13.75C14.095 18.125 14.375 17.845 14.375 17.5C14.375 17.155 14.095 16.875 13.75 16.875H12.2917V14.7917H15C17.015 14.7917 18.125 13.6817 18.125 11.6667V5C18.125 2.985 17.015 1.875 15 1.875ZM5 3.125H15C16.3142 3.125 16.875 3.68583 16.875 5V10.2083H3.125V5C3.125 3.68583 3.68583 3.125 5 3.125ZM11.0417 16.875H8.95833V14.7917H11.0417V16.875ZM15 13.5417H11.6667H8.33333H5C3.68583 13.5417 3.125 12.9808 3.125 11.6667V11.4583H16.875V11.6667C16.875 12.9808 16.3142 13.5417 15 13.5417Z"
        fill="#888888"
      />
    </svg>
  );
};
